import { render, staticRenderFns } from "./tp-order-manager.vue?vue&type=template&id=0ff35f96&scoped=true&"
import script from "./tp-order-manager.vue?vue&type=script&lang=js&"
export * from "./tp-order-manager.vue?vue&type=script&lang=js&"
import style0 from "./tp-order-manager.vue?vue&type=style&index=0&id=0ff35f96&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff35f96",
  null
  
)

export default component.exports